// src/data/modules/friendship-modules-index.js
import friendshipModule01 from "./friendship-module01-social-brain";
import friendshipModule02 from "./friendship-module02-group-dynamics";
import friendshipModule03 from "./friendship-module03-healthy-conflict";
import friendshipModule04 from "./friendship-module04-digital-drama";
import friendshipModule05 from "./friendship-module05-friendship-endings";
import friendshipModule06 from "./friendship-module06-finding-your-people";
import friendshipModule07 from "./friendship-module07-confidence-code";
import friendshipModule08 from "./friendship-module08-mastery";

export const friendshipModules = [
  friendshipModule01,
  friendshipModule02,
  friendshipModule03,
  friendshipModule04,
  friendshipModule05,
  friendshipModule06,
  friendshipModule07,
  friendshipModule08,
];

export const moduleCategories = {
  understanding: {
    title: "Understanding",
    description: "The science behind friendship dynamics",
    color: "blue",
    modules: [1, 2],
  },
  skills: {
    title: "Core Skills",
    description: "Essential techniques for navigation",
    color: "green",
    modules: [3, 4],
  },
  emotional: {
    title: "Emotional Mastery",
    description: "Processing and transitions",
    color: "purple",
    modules: [5, 6],
  },
  advanced: {
    title: "Advanced Mastery",
    description: "Confidence and leadership",
    color: "amber",
    modules: [7, 8],
  },
};

export const assessmentDimensions = [
  {
    id: "social-dynamics",
    title: "Social Dynamics Understanding",
    description: "How well you understand group behaviour patterns",
    questions: [
      "I understand why friend groups have natural size limits",
      "I can identify different roles people play in groups",
      "I recognise when groups are creating unhealthy dynamics",
    ],
  },
  {
    id: "emotional-regulation",
    title: "Emotional Regulation",
    description: "Your ability to manage friendship-related emotions",
    questions: [
      "I can calm myself when social situations trigger anxiety",
      "I handle rejection without catastrophising",
      "I can sit with friendship grief without minimising it",
    ],
  },
  {
    id: "conflict-skills",
    title: "Conflict Resolution Skills",
    description: "How effectively you handle disagreements",
    questions: [
      "I can address conflict without avoiding or exploding",
      "I know how to repair relationships after fights",
      "I can disagree while maintaining respect",
    ],
  },
  {
    id: "digital-literacy",
    title: "Digital Friendship Literacy",
    description: "Navigation of online friendship dynamics",
    questions: [
      "I understand why people act differently online",
      "I can set digital boundaries effectively",
      "I handle online drama without escalation",
    ],
  },
  {
    id: "boundary-setting",
    title: "Boundary Setting",
    description: "Your ability to maintain healthy boundaries",
    questions: [
      "I can say no without excessive guilt",
      "I maintain my values even under peer pressure",
      "I recognise and respond to boundary violations",
    ],
  },
  {
    id: "authenticity",
    title: "Authentic Connection",
    description: "Ability to be genuine in relationships",
    questions: [
      `I can be myself even when it"s uncomfortable`,
      "I choose belonging over fitting in",
      "I attract friends who accept the real me",
    ],
  },
  {
    id: "transition-skills",
    title: "Transition Management",
    description: "Handling friendship changes and endings",
    questions: [
      "I can let friendships end without bitterness",
      "I adapt friendships to life changes",
      "I process friendship grief healthily",
    ],
  },
  {
    id: "leadership",
    title: "Social Leadership",
    description: "Ability to positively influence group dynamics",
    questions: [
      "I model healthy friendship behaviour",
      "I can shift group dynamics positively",
      "Others seek my friendship advice",
    ],
  },
];

export const programMetadata = {
  title: "Friendship Navigator",
  subtitle: "Master the art of authentic connection",
  description: "Science-based skills for navigating the complex world of modern friendships",
  targetAudience: "Young adults (13-25)",
  totalDuration: "4-6 hours of core content",
  outcomes: [
    "Understand the neuroscience of social connection",
    "Navigate group dynamics and digital drama",
    "Master healthy conflict resolution",
    "Build authentic, lasting friendships",
    "Become a positive influence in all your social circles",
  ],
};